<template>
  <qx-card-form title="申请信息">
    <qx-custom-form :noSubBtn="true" ref="baseForm" :formData="baseForm" labelWidth="120px">
      <span class="tip" slot="interestTip">
        <el-tooltip content="利息 = 申请金额 - 本金">
          <i class="el-icon-question warning"></i>
        </el-tooltip>
      </span>
    </qx-custom-form>
  </qx-card-form>
</template>

<script>
import {
  mapState,
} from 'vuex';
import {
  getDepartmentAllList,
} from 'api';
import {
  manageCostType,
  manageGetBudgetBalance,
} from 'api/cost';
export default {
  data () {
    return {
      // 是否展示预算信息
      isBeyond: false,
      // 无预算显示状态
      noBudget: false,
      // 超出预算显示状态
      exceed: false,
      // 有预算金额
      budget: 0,
      // 超出预算金额
      finalBudget: 0,
      baseForm: {
        orgIdOptions: [],
        payTypeOptions: [],
        form: [
          {
            label: '申请人',
            value: 'applyUserName',
            type: 'input',
            disabled: true,
          },
          {
            label: '申请时间',
            value: 'applyTime',
            type: 'date',
            disabled: true,
            attr: {
              time: '00:00:00',
            },
          },
          {
            label: '费用类型',
            value: 'payType',
            type: 'cascader',
            default: [],
            normal: true,
            disabled: false,
            onChange: () => {
              this.handlePayTypeChange();
            },
          },
          {
            label: '费用归属日期',
            value: 'feeAscriptionDate',
            type: 'date',
            default: '',
            attr: {
              time: '00:00:00',
            },
            onChange: () => {
              this.handlePayTypeChange();
            },
          },
          {
            label: '费用归属',
            value: 'orgId',
            type: 'select',
            onChange: () => {
              this.handlePayTypeChange();
            },
          },
          {
            label: '申请金额',
            value: 'payAmt',
            type: 'input',
            disabled: false,
            onChange: () => {
              this.handlePayAmt();
            },
          },
          {
            label: '是否开票',
            value: 'isNeedBill',
            type: 'select',
            disabled: false,
            options: [
              {
                label: '否',
                value: 0,
              },
              {
                label: '是',
                value: 1,
              },
            ],
          },
          {
            label: '消费金额',
            value: 'etcTrafficFee',
            type: 'input',
            hide: true,
            onInput: () => {
              this.handleEtcPayAmt();
            },
          },
          {
            label: '服务费',
            value: 'etcServiceFee',
            type: 'input',
            hide: true,
            onInput: () => {
              this.handleEtcPayAmt();
            },
          },
          {
            label: '滞纳金',
            value: 'etcLateFee',
            type: 'input',
            hide: true,
            onInput: () => {
              this.handleEtcPayAmt();
            },
          },
          {
            label: '本金',
            value: 'principal',
            type: 'input',
            hide: true,
            onInput: () => {
              this.handleInterest();
            },
          },
          {
            label: '利息',
            value: 'interest',
            type: 'input',
            hide: true,
            disabled: true,
          },
          {
            label: '申请原因',
            value: 'payRemark',
            type: 'input',
            attr: {
              type: 'textarea',
            },
          },
          {
            label: '上传附件',
            value: 'file',
            type: 'img',
            accept: 'image/*',
            fileSize: 5120,
            default: [],
          },
        ],
        rules: {
          payType: [ // 费用类型
            { required: true, message: '请选择费用类型', trigger: 'blur' },
          ],
          feeAscriptionDate: [ // 费用归属日期
            { required: true, message: '请选择费用归属日期', trigger: 'blur' },
          ],
          orgId: [ // 费用归属
            { required: true, message: '请选择费用归属', trigger: 'blur' },
          ],
          payAmt: [ // 申请金额
            { required: true, message: '请输入申请金额', trigger: 'blur' },
          ],
          etcTrafficFee: [ // 消费金额
            { required: true, message: '请输入消费金额', trigger: 'blur' },
          ],
          etcServiceFee: [ // 服务费
            { required: true, message: '请输入服务费', trigger: 'blur' },
          ],
          etcLateFee: [ // 滞纳金
            { required: true, message: '请输入滞纳金', trigger: 'blur' },
          ],
          principal: [ // 本金
            { required: true, message: '请输入本金', trigger: 'blur' },
          ],
          interest: [ // 利息
            { required: true, message: '请输入利息', trigger: 'blur' },
          ],
        },
      },
    };
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.user.userInfo, // 用户信息
    }),
  },
  methods: {
    async handlePayTypeChange () { // 费用类型
      let payType = this.$refs.baseForm.getVal('payType');
      payType = payType[payType.length - 1];
      // etc
      this.setFormAttrVal({
        form: this.baseForm,
        attr: 'hide',
        value: payType !== 4300,
        names: ['etcTrafficFee', 'etcServiceFee', 'etcLateFee'],
      });
      this.setFormAttrVal({
        form: this.baseForm,
        attr: 'disabled',
        value: payType === 4300,
        names: ['payAmt'],
      });
      // 银行贷款、应收保理
      this.setFormAttrVal({
        form: this.baseForm,
        attr: 'hide',
        value: payType !== 4302 && payType !== 4303,
        names: ['principal', 'interest'],
      });
      this.$emit('getOtherFormVal', {
        from: 'receipt',
        tar: 'baseForm',
      });

      this.setBudgetAndShowTips();
    },
    handlePayAmt () { // 申请金额
      this.$emit('getOtherFormVal', {
        from: 'receipt',
        tar: 'baseForm',
      });
      this.handleInterest();
    },
    handleInterest () { // 利息
      let payAmt = this.$refs.baseForm.getVal('payAmt');
      payAmt = !isNaN(payAmt) ? Number(payAmt) : 0;
      let principal = this.$refs.baseForm.getVal('principal');
      principal = !isNaN(principal) ? Number(principal) : 0;
      this.$refs.baseForm.setVal('interest', payAmt - principal);
    },
    // 计算预算和展示提示
    async setBudgetAndShowTips () {
      this.isBeyond = false;
      let costType = this.$refs.baseForm.getVal('payType');
      if (costType && costType.length) {
        costType = costType[costType.length - 1];
        this.noBudget = false;
        this.exceed = false;
        this.budget = 0;
        this.finalBudget = 0;

        const orgId = this.$refs.baseForm.getVal('orgId');
        const month = this.$refs.baseForm.getVal('feeAscriptionDate');
        const resBudgetBalance = await manageGetBudgetBalance({
          costType,
          orgId,
          month: this.formatDate(month, 3).split('-').join(''),
        });
        if (costType === 4308) {
          // 找油网
          this.$emit('getRechargeAccount');
        }
        if (!resBudgetBalance.failed) {
          this.isBeyond = true;
          if (resBudgetBalance.sumBudget === null || resBudgetBalance.sumBudget === undefined) {
            this.noBudget = true;
            this.exceed = false;
            return;
          }
          // 有预算额度
          const payAmt = this.$refs.baseForm.getVal('payAmt');
          let amt = payAmt ? Number(payAmt) : 0;
          let remainAmt = resBudgetBalance.sumBudgetBalance ? (resBudgetBalance.sumBudgetBalance / 100).toFixed(2) : 0;
          this.budget = remainAmt;
          if (amt - Number(remainAmt) > 0) {
            this.exceed = true;
            this.finalBudget = (amt - Number(remainAmt)).toFixed(2);
          } else {
            this.exceed = false;
          }
        }
      }
    },
    handleEtcPayAmt () { // 自动计算申请金额
      const etcTrafficFee = this.$refs.baseForm.getVal('etcTrafficFee');
      const etcServiceFee = this.$refs.baseForm.getVal('etcServiceFee');
      const etcLateFee = this.$refs.baseForm.getVal('etcLateFee');
      const payAmt = Number(etcTrafficFee || 0) + Number(etcServiceFee || 0) + Number(etcLateFee || 0);
      this.$refs.baseForm.setVal('payAmt', isNaN(payAmt) ? 0 : Number(payAmt));
      this.$emit('getOtherFormVal', {
        from: 'receipt',
        tar: 'baseForm',
      });
    },
    async getList () {
      this.baseForm.orgIdOptions = await getDepartmentAllList();
      this.baseForm.payTypeOptions = await manageCostType();
    },
    async handleSubData (cache) {
      let formData;
      if (cache) {
        formData = await this.$refs.baseForm.getVal();
      } else {
        formData = await this.$refs.baseForm.sub();
      }
      if (formData || cache) {
        formData.payType = formData.payType[formData.payType.length - 1];
        if (formData.applyTime) { // 申请时间
          formData.applyTime = this.formatDate(formData.applyTime, 1);
        }
        if (formData.feeAscriptionDate) { // 费用归属日期
          formData.feeAscriptionDate = this.formatDate(formData.feeAscriptionDate, 1);
        }
        if (formData.file) { // 上传附件
          const file = formData.file;
          const fileId = [];
          const fileUrl = [];
          file.forEach((item) => {
            fileId.push(item.id);
            fileUrl.push(item.url);
          });
          formData.fileId = fileId;
          formData.fileUrl = fileUrl;
          delete formData.file;
        }
      }
      return formData;
    },
    async cacheData () {
      const res = await this.handleSubData(true);
      return res;
    },
    async sub () {
      const res = await this.handleSubData();
      if (res) {
        res.applyOrgName = this.userInfo.tenantName;
        if (!res.etcTrafficFee) { // 消费金额
          res.etcTrafficFee = 0;
        }
        if (!res.etcServiceFee) { // 服务费
          res.etcServiceFee = 0;
        }
        if (!res.etcLateFee) { // 滞纳金
          res.etcLateFee = 0;
        }
        if (!res.principal) { // 本金
          res.principal = 0;
        }
        if (!res.interest) { // 利息
          res.interest = res.payAmt - res.principal;
        }
        if (res.fileId) {
          res.fileId = res.fileId.join(',');
        }
      }
      return res;
    },
    async init (data = {}) {
      let payType = data.payType || this.$route.query.payType;
      if (data.isNeedBill === undefined) {
        data.isNeedBill = 1;
      }
      if (payType) {
        payType = Number(payType);
        const result = [];
        for (let i = 0; i < this.baseForm.payTypeOptions.length; i++) {
          if (this.baseForm.payTypeOptions[i].value === payType) {
            result.push(this.baseForm.payTypeOptions[i].value);
            break;
          }
          if (this.baseForm.payTypeOptions[i].children) {
            for (let j = 0; j < this.baseForm.payTypeOptions[i].children.length; j++) {
              if (this.baseForm.payTypeOptions[i].children[j].value === payType) {
                result.push(this.baseForm.payTypeOptions[i].value);
                result.push(this.baseForm.payTypeOptions[i].children[j].value);
                break;
              }
            }
          }
        }
        data.payType = result;
      } else {
        data.payType = [];
      }
      if (!data.applyUserName) { // 申请人
        data.applyUserName = this.userInfo.staffTFInfo.linkman;
      }
      if (!data.orgId) { // 费用归属
        data.orgId = Number(this.userInfo.staffTFInfo.orgIds.split(',')[0]);
      }
      if (data.applyTime) { // 申请时间
        data.applyTime = new Date(data.applyTime);
      } else {
        data.applyTime = new Date();
      }
      if (data.feeAscriptionDate) { // 费用归属日期
        data.feeAscriptionDate = new Date(data.feeAscriptionDate);
      } else {
        data.feeAscriptionDate = new Date();
      }
      if (data.fileId) { // 上传附件
        data.file = data.fileId.map((id, index) => ({
          id,
          url: data.fileUrl[index],
        }));
      } else {
        data.file = [];
      }
      this.$refs.baseForm.setVal('form', data);
      this.handlePayTypeChange();
      this.handleInterest();
      this.setFormAttrVal({
        form: this.baseForm,
        attr: 'disabled',
        value: Boolean(this.$route.query.payType),
        names: ['payType', 'isNeedBill'],
      });

      this.setFormAttrVal({
        form: this.baseForm,
        attr: 'disabled',
        value: Boolean(this.$route.query.id),
        names: ['payType', 'isNeedBill'],
      });
    },
  },
};
</script>

<style scoped lang="scss">
.tip {
  margin-left: 8px;
}
</style>
